import { Adg4Tabs } from "@/components/adg4/tabs/src";
import { Megaphone } from "@/libraries/wpl/foundations/src/icons/software/megaphone";
import { Notepad } from "@/libraries/wpl/foundations/src/icons/software/notepad";
import { Rocket } from "@/libraries/wpl/foundations/src/icons/software/rocket";
import { ContentTypeVideo } from "@/templates/software/confluence/confluence-software-page/src/sections/content-types/content-type-video";

export const isTargetedKeyword = (keyword = "") =>
    [
        "document editor",
        "documento editor",
        "document sharing",
        "doc editing",
        "editar um documento",
        "editar documentos online",
        "doc editing online",
        "doc editor online",
        "text editor online",
        "word",
        "notion",
        "google docs",
        "microsoft word",
        "microsoft word en línea",
        "word gratis",
        "word editor",
        "word online",
        "microsoft word gratis descargar",
        "microsoft office",
        "spreadsheets",
        "google sheets",
        "project plan",
        "project management tool",
        "project management platform",
        "software project management tools",
        "project management template",
        "plan del proyecto",
        "task list",
        "digital diagram",
        "diagrama digital",
        "diagrama de flujo",
        "online flow chart",
        "creador de diagramas de flujo",
        "diagramas de flujo online",
        "hacer un diagrama de flujo",
        "diagrama de flujo online",
        "programas para hacer diagramas de flujo",
        "fluxograma online",
        "diagrama de flujo online gratis",
        "flowchart",
        "criar mapas mentais"
    ].includes(keyword);

export const getPageId = (keyword = "") => {
    return (
        {
            "document editor": "paid-lp-conf-keywords-documentation",
            "documento editor": "paid-lp-conf-keywords-documentation",
            "document sharing": "paid-lp-conf-keywords-documentation",
            "doc editing": "paid-lp-conf-keywords-documentation",
            "editar um documento": "paid-lp-conf-keywords-documentation",
            "editar documentos online": "paid-lp-conf-keywords-documentation",
            "doc editing online": "paid-lp-conf-keywords-documentation",
            "doc editor online": "paid-lp-conf-keywords-documentation",
            "text editor online": "paid-lp-conf-keywords-documentation",
            "word": "paid-lp-conf-keywords-competitors",
            "notion": "paid-lp-conf-keywords-competitors",
            "google docs": "paid-lp-conf-keywords-competitors",
            "microsoft word": "paid-lp-conf-keywords-competitors",
            "microsoft word en línea": "paid-lp-conf-keywords-competitors",
            "word gratis": "paid-lp-conf-keywords-competitors",
            "word editor": "paid-lp-conf-keywords-competitors",
            "word online": "paid-lp-conf-keywords-competitors",
            "microsoft word gratis descargar":
                "paid-lp-conf-keywords-competitors",
            "microsoft office": "paid-lp-conf-keywords-competitors",
            "spreadsheets": "paid-lp-conf-keywords-spreadsheets",
            "google sheets": "paid-lp-conf-keywords-spreadsheets",
            "project plan": "paid-lp-conf-keywords-project-plan",
            "project management tool": "paid-lp-conf-keywords-project-plan",
            "project management platform": "paid-lp-conf-keywords-project-plan",
            "software project management tools":
                "paid-lp-conf-keywords-project-plan",
            "project management template": "paid-lp-conf-keywords-project-plan",
            "plan del proyecto": "paid-lp-conf-keywords-project-plan",
            "task list": "paid-lp-conf-keywords-task-list",
            "digital diagram": "paid-lp-conf-keywords-digital-diagram",
            "diagrama digital": "paid-lp-conf-keywords-digital-diagram",
            "diagrama de flujo": "paid-lp-conf-keywords-digital-diagram",
            "online flow chart": "paid-lp-conf-keywords-digital-diagram",
            "creador de diagramas de flujo":
                "paid-lp-conf-keywords-digital-diagram",
            "diagramas de flujo online":
                "paid-lp-conf-keywords-digital-diagram",
            "hacer un diagrama de flujo":
                "paid-lp-conf-keywords-digital-diagram",
            "diagrama de flujo online": "paid-lp-conf-keywords-digital-diagram",
            "programas para hacer diagramas de flujo":
                "paid-lp-conf-keywords-digital-diagram",
            "fluxograma online": "paid-lp-conf-keywords-digital-diagram",
            "diagrama de flujo online gratis":
                "paid-lp-conf-keywords-digital-diagram",
            "flowchart": "paid-lp-conf-keywords-digital-diagram",
            "criar mapas mentais": "paid-lp-conf-keywords-mental-map"
        }[keyword] || "paid-lp-conf-keywords-documentation"
    );
};

export const generateTabComponent = (
    keyword = "",
    tab: {
        title: string;
        description: string;
        content: string;
    }
) => {
    let videoProps;

    if (["spreadsheets", "google sheets"].includes(keyword)) {
        videoProps = {
            videoSrcMp4:
                "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR_reencode.mp4",
            videoSrcWebm:
                "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR.webm",
            videoPreviewSrc:
                "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Databases_Preview.webp"
        };
    } else if (
        [
            "digital diagram",
            "diagrama digital",
            "diagrama de flujo",
            "criar mapas mentais",
            "online flow chart",
            "creador de diagramas de flujo",
            "diagramas de flujo online",
            "hacer un diagrama de flujo",
            "diagrama de flujo online",
            "programas para hacer diagramas de flujo",
            "fluxograma online",
            "diagrama de flujo online gratis",
            "flowchart"
        ].includes(keyword)
    ) {
        videoProps = {
            videoSrcMp4:
                "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR_reencode.mp4",
            videoSrcWebm:
                "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR.webm",
            videoPreviewSrc:
                "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Whiteboards_Preview.webp"
        };
    } else {
        videoProps = {
            videoSrcMp4:
                "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR_reencode.mp4",
            videoSrcWebm:
                "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR.webm",
            videoPreviewSrc:
                "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Pages_Preview.webp"
        };
    }

    return (
        <Adg4Tabs>
            <ContentTypeVideo
                {...videoProps}
                showBackground={true}
                active={true}
                showAsterisks={true}
                hideSeparator={true}
                title={tab.title}
                description={tab.description}
                iconCollection={Array.from(
                    new DOMParser()
                        .parseFromString(tab.content, "text/html")
                        .querySelectorAll("p")
                )
                    .slice(0, 3)
                    .map((p, i) => ({
                        description: p.textContent || "",
                        icon: [
                            <Rocket key="Rocket" size="small" />,
                            <Megaphone key="Megaphone" size="small" />,
                            <Notepad key="Notepad" size="small" />
                        ][i]
                    }))}
            />
        </Adg4Tabs>
    );
};

export const getAnimationByKeyword = (keyword: string) => {
    let animation;

    if (["spreadsheets", "google sheets"].includes(keyword)) {
        animation = import("./lotties/Spreadsheet.json") as Promise<unknown>;
    } else if (
        [
            "digital diagram",
            "diagrama digital",
            "diagrama de flujo",
            "criar mapas mentais",
            "online flow chart",
            "creador de diagramas de flujo",
            "diagramas de flujo online",
            "hacer un diagrama de flujo",
            "diagrama de flujo online",
            "programas para hacer diagramas de flujo",
            "fluxograma online",
            "diagrama de flujo online gratis",
            "flowchart"
        ].includes(keyword)
    ) {
        animation = import("./lotties/Whiteboard.json") as Promise<unknown>;
    } else if (
        [
            "project plan",
            "project management tool",
            "project management platform",
            "software project management tools",
            "project management template",
            "plan del proyecto"
        ].includes(keyword)
    ) {
        animation = import("./lotties/Projectplan.json") as Promise<unknown>;
    } else if (["task list"].includes(keyword)) {
        animation = import("./lotties/Weeklytasks.json") as Promise<unknown>;
    } else {
        animation = import("./lotties/Page.json") as Promise<unknown>;
    }
    return animation ? { lottieAnimationPromise: animation } : undefined;
};
